import * as types from "@/redux/types";

export const setSidebarActiveTabHandler = (activeTab) => ({
    payload: { activeTab },
    type: types.SET_SIDEBAR_ACTIVE_TAB,
});
